module.exports = __webpack_public_path__ + "img/register-pj.0879418b.jpg";